import React, { useState } from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
} from "reactstrap";
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import * as moment from "moment";
import TableLoader from "../../../components/Common/TableLoader";

function Table(props) {
  const { data } = props;

  // Calculate totals for each column
  const totals = data.reduce(
    (acc, curr) => {
      acc.unique_players += curr.unique_players;
      acc.total_stake += curr.total_stake;
      acc.stake_tax += curr.stake_tax;
      acc.effective_stake += curr.effective_stake;
      acc.boost += curr.boost;
      acc.wht += curr.wht;
      acc.payout += curr.payout;
      acc.ggr += curr.ggr;
      acc.NGR += curr.NGR;
      return acc;
    },
    {
      unique_players: 0,
      total_stake: 0,
      stake_tax: 0,
      effective_stake: 0,
      boost: 0,
      wht: 0,
      payout: 0,
      ggr: 0,
      NGR: 0,
    }
  );

  const columns = [
    {
      dataField: "day",
      text: "Day Of Month",
      sort: true,
      footer: "Total:",
    },
    {
      dataField: "unique_players",
      text: "Unique Players",
      sort: true,
      footer: totals.unique_players.toLocaleString("en-GB"),
      formatter: (cell, row) => <>{Number(parseFloat(row.unique_players ?? 0)?.toFixed(2)).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "total_stake",
      text: "Total Stake",
      sort: true,
      footer: totals.total_stake.toLocaleString("en-GB"),
      formatter: (cell, row) => <>{Number(row.total_stake.toFixed(2)).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "stake_tax",
      text: "Stake Tax",
      sort: true,
      footer: totals.stake_tax.toLocaleString("en-GB"),
      formatter: (cell, row) => <>{Number(row.stake_tax.toFixed(2)).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "effective_stake",
      text: "Effective Stake",
      sort: true,
      footer: totals.effective_stake.toLocaleString("en-GB"),
      formatter: (cell, row) => <>{Number(row.effective_stake.toFixed(2)).toLocaleString('en-GB')}</>
    },
    {
      dataField: "boost",
      text: "Boost",
      sort: true,
      footer: totals.boost.toLocaleString("en-GB"),
      formatter: (cell, row) => <>{Number(row.boost.toFixed(2)).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "wht",
      text: "WHT",
      sort: true,
      footer: totals.wht.toLocaleString("en-GB"),
      formatter: (cell, row) => <>{Number(row.wht.toFixed(2)).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "payout",
      text: "Pay out",
      sort: true,
      footer: totals.payout.toLocaleString("en-GB"),
      formatter: (cell, row) => <>{Number(row.payout.toFixed(2)).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "ggr",
      text: "GGR",
      sort: true,
      footer: totals.ggr.toLocaleString("en-GB"),
      formatter: (cell, row) => (
        <>{Number(row.ggr.toFixed(2)).toLocaleString("en-GB")}</>
      ),
    },
    {
      dataField: "NGR",
      text: "NGR",
      sort: true,
      footer: totals.NGR.toLocaleString("en-GB"),
      formatter: (cell, row) => (
        <>{Number(row.NGR.toFixed(2)).toLocaleString("en-GB")}</>
      ),
    },
  ];

  const defaultSorted = [
    {
      dataField: "orderId",
      order: "desc",
    },
  ];

  const { SearchBar } = Search;
  //pagination customization

  const pageOptions = {
    sizePerPage: data.length,
    totalSize: data.length,
    custom: true,
  };

  return (
    <>
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">{"GGR Report"}</div>
          {props.loadingMessage && props.loadingMessage === "1" ? (
            <TableLoader />
          ) : (
            <PaginationProvider
              pagination={paginationFactory(pageOptions)}
              keyField="id"
              columns={columns}
              data={data}
            >
              {({ paginationProps, paginationTableProps }) => (
                <ToolkitProvider
                  keyField="id"
                  data={data}
                  columns={columns}
                  bootstrap4
                  search
                >
                  {(toolkitProps) => (
                    <React.Fragment>
                      <Row className="mb-2">
                        <Col sm="6">
                          <Row>
                            <Col sm="6">
                              <div className="search-box me-2 mb-2 d-inline-block">
                                <div className="position-relative">
                                  <SearchBar {...toolkitProps.searchProps} />
                                  <i className="bx bx-search-alt search-icon" />
                                </div>
                              </div>
                            </Col>
                            <Col sm="6">
                              <div>
                                <ReactHTMLTableToExcel
                                  id="test-table-xls-button"
                                  className="download-table-xls-button w-md btn btn-primary"
                                  table="table-to-xls"
                                  filename={`GGR-Report-${moment(new Date()).format("DD/MM/YYYY")}`}
                                  sheet="tablexls"
                                  buttonText="Download"
                                  type="button"
                                />
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col sm={6}></Col>
                      </Row>
                      <Row>
                        <Col xl="12">
                          <div className="table-responsive">
                            <BootstrapTable
                              id="table-to-xls"
                              keyField="id"
                              responsive
                              bordered={false}
                              striped={false}
                              defaultSorted={defaultSorted}
                              classes={"table align-middle table-nowrap table-check"}
                              headerWrapperClasses={"table-light"}
                              {...toolkitProps.baseProps}
                              {...paginationTableProps}
                              rowClasses={"mytable-hover-row"}
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="pagination pagination-rounded justify-content-end">
                        <PaginationListStandalone {...paginationProps} />
                      </div>
                    </React.Fragment>
                  )}
                </ToolkitProvider>
              )}
            </PaginationProvider>
          )}
        </CardBody>
      </Card>
    </>
  );
}

export default Table;
